<script>
import { Router } from 'svelte-router-spa';
import { routes } from './router';


// import FlashHolder from 'components/elements/flash/Holder.svelte';
// pass flashed_messages ....
import { GoogleAnalytics } from '@beyonk/svelte-google-analytics';


import 'bulma/css/bulma.min.css';

</script>


<style>
	
main {
	min-height: calc(100vh - var(--navbar-height));
	margin-top: var(--navbar-height);
}

</style>


<GoogleAnalytics properties={['G-8F38W9K4GX']} />


<main>
	<Router {routes} />
</main>


